// @ts-nocheck
/**
 * Action constants for report-page filter persistence.
 * Fix R02 (hot-fix regression): startDate/endDate on /reports/contractor-work
 * were resetting when leaving and returning because they were local useState.
 * Now Redux state survives navigation (and refresh, via the redux-persist whitelist).
 */
export const UPDATE_REPORT_FILTERS = "UPDATE_REPORT_FILTERS";
export const RESET_REPORT_FILTERS = "RESET_REPORT_FILTERS";
